module.exports = __webpack_public_path__ + "static/Nahe2-scaled-76f0679ef1cc153f32414d49c7600c7f.jpeg";